import React from 'react';
import validator from 'validator';
import { IDynamicFormInputErrors } from '../components/DynamicForm/IDynamicFormTypes';

export const useValidateInput = (
    name: string,
    inputErrors: IDynamicFormInputErrors,
    setInputErrors: React.Dispatch<
        React.SetStateAction<IDynamicFormInputErrors>
    >,
    value?: string,
    type?: string,
    multiple?: boolean
) => {
    if (validator.isEmpty(value)) {
        if (name === `comments`) {
            return;
        }
        if (type === `SELECT`) {
            if (multiple) {
                return setInputErrors({
                    ...inputErrors,
                    [name]: `At least one selection is required.`,
                });
            }
            setInputErrors({
                ...inputErrors,
                [name]: `Selection required.`,
            });
        } else {
            setInputErrors({ ...inputErrors, [name]: `Required.` });
        }
    } else if (
        name === `first_name` &&
        !validator.isAlpha(value, `en-US`, { ignore: ` -` })
    ) {
        setInputErrors({
            ...inputErrors,
            [name]: `First name must contain alphabetical letters only`,
        });
    } else if (
        name === `last_name` &&
        !validator.isAlpha(value, `en-US`, { ignore: ` -` })
    ) {
        setInputErrors({
            ...inputErrors,
            [name]: `Last name must contain alphabetical letters only`,
        });
    } else if (
        (name === `postal_code` || name === `zip_code`) &&
        !validator.isPostalCode(value, `any`)
    ) {
        setInputErrors({
            ...inputErrors,
            [name]: `Required.  Must be a valid postal code.`,
        });
    } else if (name === `contact_number` && !validator.isMobilePhone(value)) {
        setInputErrors({
            ...inputErrors,
            [name]: `Required.  Numbers only.`,
        });
    } else if (
        (name === `email_address` || name === `email`) &&
        !validator.isEmail(value)
    ) {
        setInputErrors({
            ...inputErrors,
            [name]: `Valid email address is required.`,
        });
    } else {
        setInputErrors({ ...inputErrors, [name]: null });
    }
};
